import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import AddIcon from '@/assets/img/ico-add.svg?react'
import SearchForm from '@/compoments/common/SearchForm'
import SelectBox from '@/compoments/common/SelectBox'
import AddNotificationModal from '@/compoments/modals/AddNotificationModal/AddNotificationModal'
import { setNotifications } from '@/features/notifications/notificationsSlice'
import useModal from '@/hooks/useModal'
import {
    useGetAllNotificationEventsQuery,
    useGetAllNotificationQuery,
} from '@/services/notifications/notifications'
import type { INotificationEvent } from '@/types/notifications'

interface INotificationHeaderProps {}

export const NotificationHeader: React.FC<INotificationHeaderProps> = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const { isOpen, closeModal, openModal } = useModal()
    const queryString = searchParams.toString()
    const dispatch = useDispatch()
    const { data } = useGetAllNotificationQuery(queryString)
    const { data: notificationEventsData } =
        useGetAllNotificationEventsQuery('no-limit')

    const [selectedOption, setSelectedOption] = useState<string | null>(
        searchParams.get('event') || null,
    )

    const updateSearchParams = (params: Record<string, string | null>) => {
        const updatedParams = new URLSearchParams(searchParams)
        Object.entries(params).forEach(([key, value]) => {
            if (value !== null) {
                updatedParams.set(key, value)
            } else {
                updatedParams.delete(key)
            }
        })
        setSearchParams(updatedParams)
    }

    const handleSelectChange = (value?: string | null) => {
        setSelectedOption(value || null)
        updateSearchParams({ page: '1' })
    }

    useEffect(() => {
        if (selectedOption) {
            dispatch(
                setNotifications(
                    data?.data?.filter(
                        (one) => one.event.id === Number(selectedOption),
                    ),
                ),
            )
        } else {
            dispatch(setNotifications(data?.data))
        }
    }, [selectedOption])

    return (
        <div className="table-header flex items-center justify-between flex-wrap">
            <div className="table-tools">
                <SelectBox
                    options={
                        notificationEventsData
                            ? notificationEventsData?.data?.map(
                                  (event: INotificationEvent) => ({
                                      label: event.name,
                                      value: String(event.id),
                                  }),
                              )
                            : []
                    }
                    placeholder="Select Event"
                    value={selectedOption || ''}
                    onChange={(option: any) =>
                        handleSelectChange(option?.value || null)
                    }
                    isClearable
                />
            </div>
            <div className="table-tools">
                <button
                    onClick={() => openModal('add-notification')}
                    className="btn btn--primary-gradient btn--sm fullRadius whitespace-nowrap"
                >
                    <AddIcon />
                    <span className="text--xs">Add Notification</span>
                </button>
                <SearchForm />
            </div>
            {isOpen('add-notification') && (
                <AddNotificationModal
                    isOpen={isOpen('add-notification')}
                    onClose={() => closeModal('add-notification')}
                />
            )}
        </div>
    )
}
